import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { headerStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

headerStyles.shareEntityButtonStyles = mergeToNew(headerStyles.shareEntityButtonStyles, {
    button: {
        buttonType: "outline",
        variant: "secondary",
        color: "common.accent",
    },
});

headerStyles.menuHiddenContainer = mergeToNew(headerStyles.menuHiddenContainer, {
    above: "md",
    css: css`
        > [class^="OverflowWrapper"] {
            width: 100%;
            > [class^="ButtonWrapper"] {
                width: 100%;
                &:focus {
                    outline: none;
                }
            }
        }
    `,
});

headerStyles.buttonGridItem = mergeToNew(headerStyles.buttonGridItem, {
    css: css`
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding-left: 0;
                        padding-right: 0;
                    `,
                ],
                "max",
            )}
    `,
});
